import React from "react";
import { DappContextProvider } from "../../contexts/MintContext";

export function TransactionErrorMessage(): React.ReactElement {
  const { transactionError, dismissTransactionError } = React.useContext(DappContextProvider);
  
  return (
    <div className="connection-message" role="alert">
      Error sending transaction: {transactionError?.substring(0, 100)}
      <button
        type="button"
        className="connection-message-close"
        data-dismiss="alert"
        aria-label="Close"
        onClick={dismissTransactionError}
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  );
}
